import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse } from '@/utils'
import { APIErrorResponse } from '@/types'

export type DeleteQuotationProps = {
  quotationId: number
}

export const useDeleteQuotation = ({
  quotationId,
}: DeleteQuotationProps): UseMutationResult<
  unknown,
  APIErrorResponse,
  void
> => {
  const client = useApiClient()

  return useMutation(() =>
    client.delete(`/quotations/${quotationId}/`).catch(unwrapErrorResponse)
  )
}
